import React, { useEffect, useState } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  CloudUploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Form, Image, Input, Upload } from "antd";
import ButtonWrapper from "../../../../views/components/reuseComp/ButtonWrapper";
import TextArea from "antd/es/input/TextArea";
import UploadFoodImage from "../../../../lib/UploadFoodImage";
import { Button } from "antd";
import UploadImage from "../../../components/UploadImage";

const OverviewSection: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  overviewData?: { heading?: string; subtext?: string; image?: string };
  loading?: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  loading,
  overviewData,
}) => {
  useEffect(() => {
    if (overviewData) {
      form.setFieldsValue({
        overview: {
          heading: overviewData.heading || "",
          subtext: overviewData.subtext || "",
          image: overviewData?.image || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [overviewData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden">
            <table className="overflow-x-auto hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Image
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Heading
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Subtext
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {overviewData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 ">
                      <Image src={overviewData?.image} width={150} />
                    </td>
                    <td className="py-3 px-4 ">{overviewData.heading}</td>
                    <td className="py-3 px-4 ">{overviewData.subtext}</td>
                    <td className="py-3 px-4 gap-4 text-primary text-center">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <table className="min-w-full border-collapse table sm:hidden">
            <tbody>
              {overviewData ? (
                <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8] sm:table-row block mb-4 sm:mb-0 rounded-lg sm:rounded-none shadow-sm sm:shadow-none">
                  <td className="py-2 px-4  block sm:table-cell">
                    <Image src={overviewData?.image} width={150}/>
                  </td>

                  <td className="py-2 px-4  block sm:table-cell">
                    <div>
                      <b className="text-primary">Heading:</b>
                    </div>
                    <p className="line-clamp-4">{overviewData?.heading}</p>
                  </td>
                  <td className="py-2 px-4  block sm:table-cell">
                    <div>
                      <b className="text-primary">Subtext:</b>
                    </div>
                    <p className="line-clamp-4">{overviewData?.subtext}</p>
                  </td>

                  <td className="py-2 px-4 text-primary block sm:table-cell">
                    <div className="flex items-center gap-4">
                      {overviewData ? (
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer text-primary text-[20px]"
                        />
                      ) : (
                        <PlusOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer text-primary text-[20px]"
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ) : (
                <tr className="bg-[#F9F9F9] border-2  border-[#e9e8e8]">
                  <td colSpan={4} className="text-center py-6 text-gray-500 ">
                    <Button type="dashed" onClick={() => setIsEditing(true)}>
                      Add data
                    </Button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-3 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["overview", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Heading" />
              </Form.Item>
              <Form.Item
                label="Subtext"
                name={["overview", "subtext"]}
                rules={[{ required: true, message: "Please enter Subtext" }]}
              >
                <TextArea placeholder="Subtext" />
              </Form.Item>

              <Form.Item
                label="Upload Image"
                name={["overview", "image"]}
                rules={[{ required: true, message: "Please upload a image" }]}
              >
                <UploadImage listType="picture-card" />
              </Form.Item>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default OverviewSection;
